module.exports = __webpack_public_path__ + "img/k.5db36b21.jpg";